// src/pages/Appli/AppliAdmin/ListingClients/charts/AssosByProduitBar.jsx

import React, { useMemo } from "react";

import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

function shortenLabel(value) {
  const label = String(value || "");

  return label.length > 22
    ? `${label.slice(0, 21)}…`
    : label;
}

export function AssosByProduitBar({
  data = [],
}) {
  const series = useMemo(() => {
    const counts = new Map();

    data.forEach((association) => {
      const product =
        association.produit_asso ||
        "Non renseigné";

      counts.set(
        product,
        (counts.get(product) || 0) + 1,
      );
    });

    const sorted = [...counts.entries()]
      .map(([name, count]) => ({
        name,
        count,
      }))
      .sort(
        (first, second) =>
          second.count - first.count,
      );

    if (sorted.length <= 10) {
      return sorted;
    }

    const visible = sorted.slice(0, 9);

    const otherCount = sorted
      .slice(9)
      .reduce(
        (sum, item) => sum + item.count,
        0,
      );

    return [
      ...visible,
      {
        name: "Autres produits",
        count: otherCount,
      },
    ];
  }, [data]);

  if (!series.length) {
    return (
      <div className="flex h-72 items-center justify-center text-sm text-slate-400">
        Aucune donnée disponible
      </div>
    );
  }

  return (
    <div className="h-72">
      <ResponsiveContainer
        width="100%"
        height="100%"
      >
        <BarChart
          data={series}
          layout="vertical"
          margin={{
            top: 5,
            right: 20,
            bottom: 5,
            left: 15,
          }}
        >
          <CartesianGrid
            strokeDasharray="3 3"
            horizontal={false}
            stroke="#cbd5e1"
            opacity={0.45}
          />

          <XAxis
            type="number"
            allowDecimals={false}
            tick={{ fill: "#94a3b8", fontSize: 11 }}
          />

          <YAxis
            type="category"
            dataKey="name"
            width={145}
            tickFormatter={shortenLabel}
            tick={{ fill: "#64748b", fontSize: 11 }}
          />

          <Tooltip
            cursor={{ fill: "#8b5cf610" }}
            formatter={(value) => [
              `${value} dossier${
                value > 1 ? "s" : ""
              }`,
              "Total",
            ]}
          />

          <Bar
            dataKey="count"
            fill="#8b5cf6"
            radius={[0, 6, 6, 0]}
            maxBarSize={24}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default AssosByProduitBar;